import RequestError from "@mittwald/api-client/dist/RequestError";
import { registerErrorReportingDataExtractionFn } from "@mittwald/flow-lib/dist/errors/errorReporting/reportingDataExtraction";
export const requestErrorInspector = (error, infos) => {
    if (!(error instanceof RequestError)) {
        return false;
    }
    const { infoTranslationKeys, details } = infos;
    infoTranslationKeys.push("api.unexpected");
    details.push({
        subject: "api.path",
        value: error.path,
    });
    details.push({
        subject: "api.method",
        value: error.method,
    });
};
registerErrorReportingDataExtractionFn((error) => {
    if (!(error instanceof RequestError)) {
        return;
    }
    return {
        noReport: true,
        tags: {
            "api.httpMethod": error.method,
        },
        extra: {
            path: error.path,
        },
    };
});
export default requestErrorInspector;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdEVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRXJyb3JCb3VuZGFyeS9yZW5kZXJpbmcvaW5zcGVjdG9ycy9yZXF1ZXN0RXJyb3IvcmVxdWVzdEVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sWUFBWSxNQUFNLHdDQUF3QyxDQUFDO0FBQ2xFLE9BQU8sRUFBRSxzQ0FBc0MsRUFBRSxNQUFNLHVFQUF1RSxDQUFDO0FBRy9ILE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUEwQixDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsRUFBRTtJQUMzRSxJQUFJLENBQUMsQ0FBQyxLQUFLLFlBQVksWUFBWSxDQUFDLEVBQUUsQ0FBQztRQUNyQyxPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCxNQUFNLEVBQUUsbUJBQW1CLEVBQUUsT0FBTyxFQUFFLEdBQUcsS0FBSyxDQUFDO0lBRS9DLG1CQUFtQixDQUFDLElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDO0lBRTNDLE9BQU8sQ0FBQyxJQUFJLENBQUM7UUFDWCxPQUFPLEVBQUUsVUFBVTtRQUNuQixLQUFLLEVBQUUsS0FBSyxDQUFDLElBQUk7S0FDbEIsQ0FBQyxDQUFDO0lBRUgsT0FBTyxDQUFDLElBQUksQ0FBQztRQUNYLE9BQU8sRUFBRSxZQUFZO1FBQ3JCLEtBQUssRUFBRSxLQUFLLENBQUMsTUFBTTtLQUNwQixDQUFDLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixzQ0FBc0MsQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFO0lBQy9DLElBQUksQ0FBQyxDQUFDLEtBQUssWUFBWSxZQUFZLENBQUMsRUFBRSxDQUFDO1FBQ3JDLE9BQU87SUFDVCxDQUFDO0lBRUQsT0FBTztRQUNMLFFBQVEsRUFBRSxJQUFJO1FBQ2QsSUFBSSxFQUFFO1lBQ0osZ0JBQWdCLEVBQUUsS0FBSyxDQUFDLE1BQU07U0FDL0I7UUFDRCxLQUFLLEVBQUU7WUFDTCxJQUFJLEVBQUUsS0FBSyxDQUFDLElBQUk7U0FDakI7S0FDRixDQUFDO0FBQ0osQ0FBQyxDQUFDLENBQUM7QUFFSCxlQUFlLHFCQUFxQixDQUFDIn0=